
import { fetch } from '@/services/base'

const paramsTransformer = ({
  dateFrom, dateTo, supervisors = [], acos = [], customers = [], zones = [], jobTypes = []
}) => (
  {
    date_to: dateTo,
    date_from: dateFrom,
    supervisors: supervisors.length ? supervisors.join(',') : undefined,
    acos: acos.length ? acos.join(',') : undefined,
    zones: zones.length ? zones.join(',') : undefined,
    customers: customers.length ? customers.join(',') : undefined,
    job_types: jobTypes.length ? jobTypes.join(',') : undefined
  }
)

/**
 * Fetches sinister count by Cycle and Process
 * @return {Promise} An http GET request
 */
const fetchSinisters = (filters = {}) => {
  return fetch('count/macro_process', {
    urlGroup: 'sinister',
    config: {
      params: paramsTransformer(filters)
    }
  })
}

export default fetchSinisters
